"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip = {
    baseStyle: {
        fontSize: '1rem',
    },
    defaultProps: {
        openDelay: 50,
        shouldWrapChildren: true,
        closeOnMouseDown: true,
    },
};
exports.default = Tooltip;
